import router from "./router";
import { ElMessage } from "element-plus";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { getToken } from "@/utils/auth";
import useUserStore from "@/store/modules/user";

NProgress.configure({ showSpinner: false });
const whiteList = ["/login", "/detail", "/news", "/article", "/aboutUs"];

router.beforeEach((to, from, next) => {
  console.log("to", to);
  NProgress.start();
  if (getToken()) {
    /* has token*/
    if (to.path === "/login") {
      next({ path: "/" });
      NProgress.done();
    } else if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      if (Object.keys(useUserStore().userInfo).length === 0) {
        // 判断当前用户是否已拉取完user_info信息
        useUserStore()
          .getInfo()
          .then(() => {
            next();
          })
          .catch((err) => {
            console.log("获取info失败，err", err);
            useUserStore()
              .logOut()
              .then(() => {
                console.log("注销用户");
                ElMessage.error(err);
                location.reload();
              });
          });
      } else {
        console.log("to", to);
        next();
      }
    }
  } else {
    next();
  }
});

router.afterEach(() => {
  NProgress.done();
});
